import PackPackage from "../../../../components/@repositories/packages/PackPackage";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PackagePackPage() {

    return (
        <PackPackage 
            routeType={routeTypes.workstation}
        />
    )
}